import { WebSocketEventType } from "@/core_bridge/module_api";

export const messageReceivedEvent = WebSocketEventType.MESSAGE_RECEIVED;
export const connectionEvent = WebSocketEventType.CONNECTION;
export const connectionOpenEvent = WebSocketEventType.CONNECTION_OPEN;
export const disconnectEvent = WebSocketEventType.DISCONNECT;
export const disconnectedEvent = WebSocketEventType.DISCONNECTED;
export const errorEvent = WebSocketEventType.ERROR;
